import { radialEffect } from '../animations/radialEffect';
import type { ThemePalette } from '../Button.types';

export const secondaryWhite = ({
  button,
  text,
  commons,
}: Pick<ThemePalette, 'button' | 'text' | 'commons'>): string => `
  background-color: transparent;
  color: ${text.link};

  &:hover {
    background-color: ${commons.tonal.hover};
  }

  ${radialEffect.active(button.background.outline.after)}
`;
